import React from 'react';
import { Database } from 'lucide-react';

const StorageIndicator = ({ storageData }) => {
  if (!storageData) return null;

  // Parse storage values
  const usedStorage = parseInt(storageData.used_storage || 0);
  const totalStorage = storageData.total_storage || 0;
  const usagePercentage = storageData.usage_percentage || 0;

  // Format bytes to human readable format
  const formatStorage = (bytes) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  // Determine color based on usage percentage
  const getProgressColor = (percentage) => {
    if (percentage < 50) return 'bg-blue-500';
    if (percentage < 80) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  // Ensure minimum visibility for very small percentages
  const displayPercentage = Math.max(usagePercentage, 0.5);

  // Format percentage
  const formatPercentage = (percent) => {
    if (percent < 1) return percent.toFixed(2);
    return Math.round(percent);
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Database className="w-4 h-4 text-gray-400" />
          <span className="text-xs font-medium text-gray-600">
            Storage
          </span>
        </div>
        <span className="text-xs font-semibold text-gray-700">
          {formatPercentage(usagePercentage)}%
        </span>
      </div>

      <div className="relative w-full bg-gray-200 rounded-full h-2 overflow-hidden">
        <div
          className={`absolute top-0 left-0 ${getProgressColor(usagePercentage)} h-2 rounded-full transition-all duration-300`}
          style={{
            width: `${Math.min(displayPercentage, 100)}%`,
            minWidth: usagePercentage > 0 ? '2px' : '0'
          }}
        />
      </div>

      <div className="flex items-center justify-center">
        <span className="text-xs text-gray-500">
          {formatStorage(usedStorage)} of {formatStorage(totalStorage)}
        </span>
      </div>
    </div>
  );
};

export default StorageIndicator;